import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MotivoCancelamento } from '../motivo-cancelamento';
import { MotivoCancelamentoService } from '../motivo-cancelamento.service';

@Component({
  selector: 'app-motivo-cancelamento-list',
  templateUrl: './motivo-cancelamento-list.component.html',
  styleUrls: ['./motivo-cancelamento-list.component.css']
})
export class MotivoCancelamentoListComponent extends AbstractCrudComponent implements OnInit {

  displayedColumns: string[] = ['descricao', 'details'];

  constructor(private motivoCancelamentoService: MotivoCancelamentoService,
    router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.motivoCancelamentoService.listar()
      .subscribe(data => {
        // console.log(data)
        this.data = data;
        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.motivoCancelamentoService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterMotivoCancelamento']);
  }

  details(entity: MotivoCancelamento) {
    this.router.navigate(['manterMotivoCancelamento'], {
      state: {
        entity: entity,
        isUpdate: 'N'
      }
    });
  }

  update(entity: MotivoCancelamento) {
    this.router.navigate(['manterMotivoCancelamento'], {
      state: {
        entity: entity,
        isUpdate: 'S'
      }
    });
  }
}
